import { useMemo, useState } from "react";
import { Table } from "../";
// import Table from '@mui/material/Table';
import { Loading } from "../../ui";

function BalanceHistoryTable({ data, isLoading, isSuperAdmin }) {
  const [copiedId, setCopiedId] = useState(null);

  function data_change(data) {
    data = data.split('T')[0]
    let str = data.slice(8,10) + "/"+ data.slice(5,7) + "/" + data.slice(0,4)
    return str
  }

  function date_time_change(dateTime) {
    if (!dateTime) return "-";
    const [date, time = ""] = dateTime.split("T");
    if (!date) return "-";
    const formattedDate = `${date.slice(8, 10)}/${date.slice(5, 7)}/${date.slice(0, 4)}`;
    const formattedTime = time.slice(0, 5);
    return formattedTime ? `${formattedDate} ${formattedTime}` : formattedDate;
  }

  const handleCopyId = (id) => {
    if (!id && id !== 0) return;
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(String(id)).catch(() => {});
    }
    setCopiedId(id);
    setTimeout(() => {
      setCopiedId((current) => (current === id ? null : current));
    }, 1500);
  };

  const columns = useMemo(
    () => {
      const cols = [];

      if (isSuperAdmin) {
        cols.push({
        Header: "ID",
        accessor: "id",
        disableGroupBy: true,
        disableSortBy: true,
        Cell: ({ cell }) => {
          const id = cell.row.original.id;
          if (!id && id !== 0) return <div>-</div>;
          return (
            <div className="BalanceHistoryTable-idCell">
              <span className="BalanceHistoryTable-idValue">{id}</span>
              <button
                type="button"
                className="BalanceHistoryTable-copyButton"
                onClick={() => handleCopyId(id)}
              >
                {copiedId === id ? "Скопировано" : "Копировать"}
              </button>
            </div>
          );
        },
        headerStyle: {
          width: 120,
        },
        cellStyle: {
          width: 160,
        },
      });
      }

      cols.push(
      {
        Header: "Дата",
        accessor: "created_at",
        disableGroupBy: true,
        Cell: ({ cell }) => (
          <div>{data_change(cell.row.original.created_at)}</div>
        ),
        headerStyle: {
          width: 120,
        },
        cellStyle: {
          width: 120,
        },
      },
      {
        Header: "Пополнение",
        accessor: "Who",
        disableSortBy: true,
        disableGroupBy: true,
        Cell: ({ cell }) => (
          <div>{(cell.row.original.type === "DEPOSIT") ? `+ ${cell.row.original.amount} ₽` : "-"}</div>
        ),
        headerStyle: {
          width: 120,
        },
        cellStyle: {
          width: 120,
        },
      },
      {
        Header: "Списание",
        accessor: "WhereFrom",
        disableSortBy: true,
        disableGroupBy: true,
        Cell: ({ cell }) => (
          <div>{(cell.row.original.type === "CHARGE") ? `- ${cell.row.original.amount} ₽` : "-"}</div>
        ),
        headerStyle: {
          width: 120,
        },
        cellStyle: {
          width: 120,
        },
      });

      if (isSuperAdmin) {
        cols.push({
          Header: "Баланс",
          accessor: "balance_after",
          disableGroupBy: true,
          disableSortBy: true,
          Cell: ({ cell }) => {
            const value = cell.row.original.balance_after;
            if (value === undefined || value === null || Number.isNaN(Number(value))) {
              return <div>-</div>;
            }
            return <div>{Number(value).toFixed(2)} ₽</div>;
          },
          headerStyle: {
            width: 140,
          },
          cellStyle: {
            width: 140,
          },
        });
      }

      cols.push({
        Header: "Описание",
        accessor: "Arrow",
        disableGroupBy: true,
        disableSortBy: true,
        Cell: ({ cell }) => (
          <div>{cell.row.original.description}</div>
        ),
        headerStyle: {
          width: 300,
        },
        cellStyle: {
          width: 300,
          borderRight: "none",
        },
      });

      if (isSuperAdmin) {
        cols.push({
          Header: "Кто и когда изменил",
          accessor: "updated_by",
          disableGroupBy: true,
          disableSortBy: true,
          Cell: ({ cell }) => (
            <div>
              {cell.row.original.admin_email
                ? `${cell.row.original.admin_email} (${date_time_change(cell.row.original.updated_at)})`
                : "-"}
            </div>
          ),
          headerStyle: {
            width: 320,
          },
          cellStyle: {
            width: 320,
            borderRight: "none",
          },
        });
      }

      return cols;
    },
    [copiedId, isSuperAdmin]
  );

  return (
    <div className="BalanceHistoryTable">
      {
        isLoading ?
          <Loading /> : // todo: fix position of loader.
          data.length 
            ? <Table columns={columns} data={data} />
            : "Не найдено"  // todo: add if not find
      }
    </div>
  );
}

export default BalanceHistoryTable;
